import React from "react";

const ourAppData = {
  ourApp: [
    // { img: "img/ourApp/01.jpg" },
    // { img: "img/ourApp/02.webp" }
  ],
  androidLink: " https://play.google.com/store/apps/details?id=com.altrange.app",
  iosLink: "https://apps.apple.com/in/app/altrange/id6749764563"
};

export const OurApp = () => {
  return (
    <div id="our-app" className="text-center" style={{ paddingTop: '6rem' }}>
      <div className="container">
        <div className="section-titles">
          <h2>Download Our App</h2>
          <p>Your gateway to a seamless experience – Get it now!</p>
        </div>

        {/* App Description */}
        <div className="app-description mb-4">
          <p>
            Our app is a dedicated designed for businesses in the
            construction and industrial sector. With our app, users can:
          </p>
          <ul className="text-start d-inline-block">
            <li>Place orders, track their real-time status, and view current account balance</li>
            <li>Raise queries, handle negotiations, and manage quotations efficiently</li>
            <li>Manage multiple sites and track issue resolutions</li>
            <li>Request refunds directly through the app</li>
          </ul>

          <p>
            Experience efficiency, transparency, and convenience — all in one app!
          </p>
        </div>

        <div className="app-download-section">
          {/* First App Box */}
          <div className="app-box">
            <a href={ourAppData.androidLink} className="btn-ourApp" target="_blank">
              <i className="fab fa-android"></i> Download for Android
            </a>
          </div>

          {/* Second App Box */}
          <div className="app-box">
            <a href={ourAppData.iosLink} className="btn-ourApp" target="_blank">
              <i className="fab fa-apple"></i> Download for Apple
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
